import React, { Component } from 'react';

import Button from 'components/shared/button/Button';

class ReviewFormForSub extends Component {
  render() {
    const {
      report,
      parentReport,
      index,
      readOnly,
      editEntry,
      currentDailyReport,
    } = this.props;

    const {
      sub_technician,
      tech_number,
      hours_worked,
      preset_tasks,
      preset_task_other,
      location,
      work_performed,
      additionalInfo,
    } = report;

    return (
      <div className="review-form-sub-wrapper">
        <div className="review-form-trade-block">
          <div className="review-form-title-block">
            <p className="review-form-block-title">
              <span>
                {sub_technician
                  ? `${sub_technician.first_name} ${
                      sub_technician.last_name || ''
                    }`
                  : `Technician ${tech_number}`}
              </span>
              <span>Total Hours: {hours_worked || 0}</span>
            </p>
            {!readOnly &&
              index === 0 &&
              currentDailyReport.status !== 'approved' && (
                <Button
                  className="button-orange"
                  label="Edit"
                  onClick={editEntry.bind(null, parentReport)}
                />
              )}
          </div>
        </div>
        {((preset_tasks && preset_tasks.length > 0) || preset_task_other) && (
          <div className="review-form-trade-block">
            <p className="review-form-block-title">Tasks Performed</p>
            <div className="review-form-block-content review-form-block-content-no-underline">
              <ul>
                {preset_tasks.length > 0 &&
                  preset_tasks.map((task) => (
                    <li key={task.id}>{task.label}</li>
                  ))}
                {preset_task_other && <li>{preset_task_other}</li>}
              </ul>
            </div>
          </div>
        )}
        {location && (
          <div className="review-form-trade-block">
            <p className="review-form-block-title">Location</p>
            <div className="review-form-text-block">{location}</div>
          </div>
        )}
        {work_performed && (
          <div className="review-form-trade-block">
            <p className="review-form-block-title">Work Performed</p>
            <div className="review-form-text-block">{work_performed}</div>
          </div>
        )}
        {additionalInfo && additionalInfo.length && (
          <React.Fragment>
            <div className="review-form-trade-block">
              <p className="review-form-block-title">Additional locations</p>
            </div>
            {additionalInfo.map((info) => (
              <div
                key={info.id}
                className="review-form-trade-block-additional-info"
              >
                <div className="review-form-trade-block">
                  <p className="review-form-block-title">
                    Total Hours: {info.hours_worked || 0}
                  </p>
                </div>
                {((info.preset_tasks && info.preset_tasks.length > 0) ||
                  info.preset_task_other) && (
                  <div className="review-form-trade-block">
                    <p className="review-form-block-title">Tasks Performed</p>
                    <div className="review-form-block-content review-form-block-content-no-underline">
                      <ul>
                        {info.preset_tasks.length > 0 &&
                          info.preset_tasks.map((task) => (
                            <li key={task.id}>{task.label}</li>
                          ))}
                        {info.preset_task_other && (
                          <li>{info.preset_task_other}</li>
                        )}
                      </ul>
                    </div>
                  </div>
                )}
                {info.location && (
                  <div className="review-form-trade-block">
                    <p className="review-form-block-title">Location</p>
                    <div className="review-form-text-block">
                      {info.location}
                    </div>
                  </div>
                )}
                {info.work_performed && (
                  <div className="review-form-trade-block">
                    <p className="review-form-block-title">Work Performed</p>
                    <div className="review-form-text-block">
                      {info.work_performed}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default ReviewFormForSub;



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-daily-report-log/ReviewFormForSub.js